<template>
  <div>
    <v-btn
      color="primary"
      :disabled="disabled"
      :x-large="xLargeButton"
      :large="largeButton"
      :small="smallButton"
      @click="showDialogButtonClickEvent"
    >
      {{ buttonCaption }}
    </v-btn>
    <v-dialog
      v-model="enableDialog"
      persistent
      width="900"
      scrollable
      @click:outside="closeDialog"
      @keydown.esc="closeDialog"
      @close="closeDialog"
    >
      <v-card flat>
        <v-toolbar flat>
          <v-toolbar-title>{{title}}</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <!-- 検索 -->
          <v-container>
            <v-row>
              <!-- 加入者番号, 名称 -->
              <v-col cols="12">
                <v-text-field
                  v-model="searchForm.query"
                  dense
                  hide-details="auto"
                  label="事業者名・加入者番号"
                  clearable
                  outlined
                  persistent-placeholder
                  placeholder="部分一致で検索"
                  rounded
                  @blur="searchButtonClickEvent"
                />
              </v-col>
              <!-- /加入者番号, 名称 -->
            </v-row>

            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                @click="searchButtonClickEvent"
              >
                <v-icon>mdi-magnify</v-icon>&nbsp;検索
              </v-btn>
            </v-card-actions>
          </v-container>
          <!-- /検索 -->

          <!-- 一覧 -->
          <v-data-table
            :headers="tableHeaders"
            :items="traders"
            :items-per-page="-1"
            disable-sort
            single-select
            hide-default-footer
            @click:row="listRowClick"
            @dblclick:row="rowDoubleClickEvent"
          >
            <!-- 取引先名 -->
            <template v-slot:[`item.name`]="{ item }">
              <div style="display: flex; align-items: center; gap: 4px;">
                <v-img
                  v-if="item.use_station"
                  max-height="18"
                  max-width="18"
                  :src="require(`@/assets/images/DXE_mark.svg`)"
                />
                <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  <span :title="item.name">{{ item.name }} </span>
                </div>
              </div>
            </template>
            <!-- /取引先名 -->
            <!-- 住所 -->
            <template v-slot:[`item.address`]="{ item }">
              <div
                :title="item.address"
                class="ellipsis-text"
                style="max-width: 250px;width: initial;font-size: 85%"
              >
                {{ item.address }}
              </div>
            </template>
            <!-- /住所 -->
          </v-data-table>
          <!-- /一覧 -->
          <v-row dense>
            <v-col>
              <v-pagination
                v-model="page"
                :length="pagination.total_pages"
                :total-visible="totalVisible"
                circle
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                @input="pageChangeEvent"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeDialog"
          >
            閉じる
          </v-btn>
          <v-btn
            :disabled="!choseTrader"
            class="primary"
            @click="registerButtonClickEvent"
          >
            反映
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ChooseTraderButton',
  components: {},
  mixins: [],
  props: {
    buttonCaption: {
      type: String,
      default: () => '事業者を選択'
    },
    /**
     * transport: 収運のみ
     * trader: 処分のみ
     * 未指定: 両方
     *
     */
    searchType: {
      type: String,
      default: () => null,
    },
    excludeMe: {
      type: Boolean,
      default: () => false,
    },
    withoutInvisible: {
      type: Boolean,
      default: () => false,
    },
    withoutNonReporting: {
      type: Boolean,
      default: () => false,
    },
    withoutNonSubscribe: {
      type: Boolean,
      default: () => false,
    },
    xLargeButton: {
      type: Boolean,
      default: () => false,
    },
    largeButton: {
      type: Boolean,
      default: () => false,
    },
    smallButton: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    exclusionIds: {
      type: Array,
      default: () => [],
    },
    withNoneLocation: {
      type: Boolean,
      default: () => false,
    }
  },
  data() {
    return {
      enableDialog: false,
      page: 1,
      totalVisible: 7,
      tableHeaders: [
        { value: 'subscriber_number', text: '加入者番号', width: '15%' },
        { value: 'name', text: '取引先名', width: '45%' },
        { value: 'address', text: '住所', width: '40%' }
      ],
      traders: [],
      choseRow: null,
      choseTrader: null,
      title: '収運・処分業者から選択',
      searchForm: {
        query: null,
      },
      pagination: {
        current_page: 1,
        total_count: 0
      },
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      this.scrollToTop()
    }
  },
  created() {
    this.setTitle()
  },
  methods: {
    ...mapActions('DriverMasterSearchTraderMember', {
      fetchTraderMembers: 'index'
    }),
    setTitle() {
      if (this.searchType === 'transport') {
        this.title = '収運業者から選択'
      } else if (this.searchType === 'trader') {
        this.title = '処分業者から選択'
      } else {
        this.title = '収運・処分業者から選択'
      }
    },
    /**
     * 請求先ボタン クリックイベント
     */
    showDialogButtonClickEvent () {
      this.traders = []
      this.choseTrader = null
      this.page = 1
      Object.assign(this.$data.searchForm, this.$options.data().searchForm)
      Object.assign(this.$data.pagination, this.$options.data().pagination)
      if (this.choseRow) {
        this.choseRow.select(false)
        this.choseRow = null
      }
      this.searchTrader()
      this.enableDialog = true
    },
    searchButtonClickEvent () {
      this.traders = []
      this.page = 1
      this.choseTrader = null
      if (this.choseRow) {
        this.choseRow.select(false)
        this.choseRow = null
      }
      this.searchTrader()
    },
    searchTrader () {
      let params = {
        search_type: this.searchType,
        exclude_me: this.excludeMe,
        without_invisible: this.withoutInvisible,
        subscriber_no: this.searchForm.subscriber_number,
        without_non_reporting: this.withoutNonReporting,
        without_non_subscribe: this.withoutNonSubscribe,
        with_none_location: this.withNoneLocation,
        query: this.searchForm.query,
        page: this.page,
      }
      this.fetchTraderMembers({params: params}).then((content) => {
        this.traders = content.traders
        this.pagination = content.pagination
      })
    },
    pageChangeEvent () {
      this.searchTrader()
    },
    /**
     * 行選択イベント
     * @param item
     * @param row
     */
    listRowClick (item, row) {
      this.choseTrader = item
      this.choseTrader.type = 'Trader'
      this.choseRow = row
      row.select(true)
    },
    rowDoubleClickEvent($event, row) {
      this.$emit("choseTraderCallback", row.item);
      this.closeDialog()
    },
    /**
     * 反映ボタン クリックイベント
     * 呼び出し元で定義されたコールバックをキックし、選択された請求先情報を返します.
     */
    registerButtonClickEvent () {
      this.$emit('choseTraderCallback', this.choseTrader)
      this.closeDialog()
    },
    /**
     * ダイアログを閉じる
     */
    closeDialog () {
      this.enableDialog = false
    },
    scrollToTop () {
      const elements = document.getElementsByClassName('v-dialog--active')
      if (!elements || !elements.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      elements[elements.length - 1].scrollTop = 0;
    },
  }
}
</script>

<style scoped lang="scss">

</style>
